<template>
  <v-container class="pa-0 ma-0 pb-8" style="height: 100%">
    <v-form class="pa-0 ma-0" ref="form" v-model="formValid" @submit.prevent>
      <v-container class="pa-0 ma-0 d-flex flex-column gap-2">
        <v-container
          v-if="personnelName || workshopName"
          class="pa-3 ma-0 d-flex justify-space-between align-center"
          style="border-bottom: 2px solid rgba(0, 0, 0, 0.1); height: 70px"
        >
          <v-card-text v-if="personnelName !== null" class="pa-0 ma-0 text-body-2">
            <span class="text-body-1"> {{ $t("personnel") }}: </span>
            <span class="text-body-2"> {{ personnelName }} </span>
          </v-card-text>
          <!-- {{ workshopName }} -->
          <v-card-text v-if="workshopName !== null" class="pa-0 ma-0 text-body-2">
            <span class="text-body-1"> {{ $t("workshop") }}: </span>
            <span class="text-body-2"> {{ workshopName }} </span>
          </v-card-text>
          <v-card-text class="pa-0 ma-0 d-flex align-center"></v-card-text>
        </v-container>
        <v-row align="center" justify="space-between" class="pa-0 ma-0">
          <!-- Right side -->
          <v-row align="center" class="ma-0">
            <!-- Start Date -->
            <v-col cols="12" sm="3" md="4" class="dateCommandment">
              <div class="d-flex flex-column gap-4">
                <v-text-field
                  id="startDate"
                  v-model="startDate"
                  :label="$t('start-date')"
                  single-line
                  outlined
                  dense
                  clearable
                />
                <date-picker
                  v-model="startDate"
                  element="startDate"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                      .primary
                  "
                />
                <v-text-field
                  id="contract_date"
                  v-model="contract_date"
                  :label="$t('contract_date')"
                  single-line
                  outlined
                  dense
                  clearable
                />
                <date-picker
                  v-model="contract_date"
                  element="contract_date"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                      .primary
                  "
                />
              </div>
            </v-col>
            <!-- End Date -->
            <v-col cols="12" sm="3" md="4" class="dateCommandment">
              <div class="d-flex flex-column gap-4">
                <v-text-field
                  id="endDate"
                  v-model="endDate"
                  :label="$t('end-date')"
                  single-line
                  outlined
                  dense
                  clearable
                />
                <date-picker
                  v-model="endDate"
                  element="endDate"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                      .primary
                  "
                />
                <v-text-field
                  :value="contract_number"
                  @input="onBaseContractInput"
                  :label="$t('contract_number')"
                  outlined
                  clearable
                  dense
                  hide-details="auto"
                  class="pa-0 ma-0 mb-4"
                  inputmode="numeric"
                />
                <!-- <v-text-field
                  id="endDate"
                  v-model="endDate"
                  :label="$t('end-date')"
                  single-line
                  outlined
                  dense
                  clearable
                />
                <date-picker
                  v-model="endDate"
                  element="endDate"
                  auto-submit
                  :color="
                    $vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light']
                      .primary
                  "
                /> -->
              </div>
            </v-col>
          </v-row>
          <!-- Left side -->
          <v-col cols="12" sm="3" md="3" class="dateCommandment mb-9">
            <div class="d-flex flex-column gap-4">
              <FlexibleAutocomplete
                v-model="saleryFactorsTemplate"
                title="select_salery_factors_template"
                type="saleryFactorsTemplate"
                :multiple="false"
                :currency="currencyId"
                :fetchData="fetchApi"
              />
              <v-container class="ma-0 pa-4"></v-container>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-container class="pa-0 ma-0 mt-1 d-flex flex-column gap-3">
        <!-- Advantages-->
        <v-container class="pa-0 ma-0 mt-1 d-flex flex-column gap-2">
          <v-card-text
            v-if="advantagesData.length > 0"
            class="pa-0 ps-4 ma-0 text-body-1"
            >{{ $t("Advantages") }}</v-card-text
          >
          <v-row align="center" class="ma-0">
            <v-col
              cols="12"
              sm="3"
              md="3"
              class="mb-2 ma-0"
              v-for="(item, index) in advantagesData"
              :key="item.name"
              v-if="advantagesData.length > 0"
            >
              <v-text-field
                :value="numberFormat(item.amount)"
                @input="onAmountInput($event, index)"
                :label="item.name"
                :suffix="currencyName"
                :rules="[rules.onlyNumber]"
                outlined
                clearable
                dense
                hide-details="auto"
                class="pa-0 ma-0"
                inputmode="numeric"
              />
            </v-col>
          </v-row>
        </v-container>
        <!-- Deductions -->
        <v-container class="pa-0 ma-0 mt-1 d-flex flex-column gap-2">
          <v-card-text
            v-if="deductionsData.length > 0"
            class="pa-0 ma-0 ps-4 text-body-1"
            >{{ $t("deductions") }}</v-card-text
          >
          <v-row align="center" class="ma-0">
            <v-col
              cols="12"
              sm="3"
              md="3"
              class="mb-2 ma-0"
              v-for="(item, index) in deductionsData"
              :key="item.name + '-ded'"
              v-if="deductionsData.length > 0"
            >
              <v-text-field
                :value="numberFormat(item.amount)"
                @input="onAmountDeductionsInput($event, index)"
                :label="item.name"
                :suffix="currencyName"
                :rules="[rules.onlyNumber]"
                outlined
                clearable
                dense
                hide-details="auto"
                class="pa-0 ma-0"
                inputmode="numeric"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-container>
      <!-- Insurer -->
      <v-container class="pa-0 ma-0 mt-9 d-flex flex-column gap-3">
        <v-card-text class="pa-0 ma-0 ps-4 text-body-1">{{
          $t("InsurerPercent")
        }}</v-card-text>
        <v-row align="center" class="ma-0">
          <v-col cols="12" sm="3" md="3" class="">
            <v-text-field
              :value="numberFormat(supplementaryInsurer)"
              @input="onSupplementaryInsurerInput"
              :label="$t('supplementaryInsurer')"
              :suffix="currencyName"
              :rules="[rules.onlyNumber]"
              outlined
              clearable
              dense
              hide-details="auto"
              class="pa-0 ma-0"
              inputmode="numeric"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="">
            <v-text-field
              v-model.number="costInsurerPercent"
              :label="$t('costInsurerPercent')"
              suffix="%"
              type="number"
              outlined
              clearable
              dense
              class="pa-0 ma-0"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="">
            <v-text-field
              v-model.number="JoblessInsurerPercent"
              :label="$t('JoblessInsurerPercent')"
              suffix="%"
              type="number"
              outlined
              clearable
              dense
              class="pa-0 ma-0"
            />
          </v-col>
          <v-col cols="12" sm="3" md="3" class="">
            <v-text-field
              v-model.number="Co_InsurerPercent"
              :label="$t('Co_InsurerPercent')"
              suffix="%"
              type="number"
              outlined
              clearable
              dense
              class="pa-0 ma-0"
            />
          </v-col>
        </v-row>
      </v-container>
      <!-- checkboxs -->
      <v-container class="pa-0 ma-0 ps-2 my-8 d-flex flex-column gap-3">
        <v-checkbox
          v-model="ApplyingTheLaw"
          :label="$t('ApplyingTheLaw')"
          class="mt-0 pt-0"
          dense
        ></v-checkbox>
        <v-checkbox
          v-model="EidBonus"
          :label="$t('EidBonus')"
          class="mt-0 pt-0"
          dense
        ></v-checkbox>
      </v-container>
      <!-- Regulation -->
      <v-container class="pa-0 ma-0 d-flex flex-column gap-6">
        <v-container class="pa-0 ma-0 my-5 d-flex flex-column gap-3">
          <v-card-text class="pa-0 ma-0 ps-4 text-body-1">{{
            $t("taxPercent")
          }}</v-card-text>
          <v-row align="center" class="ma-0">
            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="TaxDeductionRegulation"
                :label="$t('Tax Deduction Regulation')"
                :items="TaxRegulation"
                outlined
                clearable
                dense
                class="pa-0 ma-0"
              />
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-select
                v-model="TaxDeductionSupplementary"
                :label="$t('TaxDeductionSupplementaryInsurerRegulation')"
                :items="supplementaryTaxRegulation"
                outlined
                clearable
                dense
                class="pa-0 ma-0"
              />
            </v-col>
            <v-col cols="12" sm="3" md="3" class="px-0">
              <v-text-field
                v-model.number="fixTaxPercent"
                :label="$t('fixTaxPercent')"
                suffix="%"
                type="number"
                outlined
                clearable
                dense
                class="pa-0 ma-0"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-row justify="end" no-gutters class="ma-0">
          <v-btn
            outlined
            @click="openDialog()"
            class="pa-0 ma-0 mx-1 my-2"
            color="gray"
            height="32"
          >
            <v-card-text class="text-body-2 ma-0 pa-0">
              {{ $t("TaxBracketViewing") }}
            </v-card-text>
          </v-btn>
        </v-row>
      </v-container>
      <CommandmentsDialog :isVisible="isVisible" @CloseDialog="handleDialog" />
    </v-form>
    <!--  snackbar --->
    <v-snackbar
      v-model="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
      top
      style="z-index: 1000000000000 !important"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          :loading="loading"
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t("close") }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import moment from "moment-jalaali";
moment.loadPersian({ dialect: "persian-modern" });
import General from "@/Mixins/general";
import CommandmentsDialog from "../partial/details/CommandmentsDialog.vue";
import FlexibleAutocomplete from "../../../../components/general/patial/FlexibleAutocomplete.vue";

export default {
  name: "commandmentsForm",
  components: {
    CommandmentsDialog,
    FlexibleAutocomplete,
  },
  mixins: [General],
  props: {
    saveNew: {
      type: Boolean,
      default: false,
    },
    saveReturn: {
      type: Boolean,
      default: false,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      return: false,
      isVisible: false,
      EidBonus: false,
      ApplyingTheLaw: false,
      isShow: false,
      formValid: null,
      contract_number: null,
      supplementaryInsurer: null,
      costInsurerPercent: null,
      JoblessInsurerPercent: null,
      Co_InsurerPercent: null,
      TaxDeductionRegulation: null,
      TaxDeductionSupplementary: null,
      fixTaxPercent: null,
      startDate: null,
      endDate: null,
      contract_date: null,
      currencyId: "",
      saleryFactorsTemplate: null,
      isHydratingTemplate: false,
      hasHydratedEditTemplate: false,
      CommitmentByConfigId: null,
      personnelName: null,
      workshopName: null,
      advantagesData: [],
      deductionsData: [],
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      TaxRegulation: [
        { text: "2/7", value: "type2.7" },
        { text: "7/7", value: "type7.7" },
      ],
      supplementaryTaxRegulation: [
        { text: "اعمال شود", value: true },
        { text: "اعمال نشود", value: false },
      ],
    };
  },
  watch: {
    "saleryFactorsTemplate.id": {
      immediate: true,
      handler(newId) {
        if (this.isHydratingTemplate) return;
        if (newId) {
          this.advantagesData = [];
          this.deductionsData = [];
          this.CommitmentByConfigId = newId;
          this.getSalaryCommitmentByConfigId(newId);
        } else {
          this.advantagesData = [];
          this.deductionsData = [];
          this.CommitmentByConfigId = null;
        }
      },
    },
    saveNew: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.save(this.return);
        }
      },
    },
    saveReturn: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.return = true;
          this.save(this.return);
        }
      },
    },
    clear: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.EidBonus = false;
          this.ApplyingTheLaw = false;
          this.contract_number = null;
          this.supplementaryInsurer = null;
          this.costInsurerPercent = null;
          this.JoblessInsurerPercent = null;
          this.Co_InsurerPercent = null;
          this.TaxDeductionRegulation = null;
          this.TaxDeductionSupplementary = null;
          this.fixTaxPercent = null;
          this.startDate = null;
          this.contract_date = null;
          this.endDate = null;
          this.advantagesData.forEach((item) => {
            item.amount = null;
          });
          this.deductionsData.forEach((item) => {
            item.amount = null;
          });
          this.$emit("clear-form");
        }
      },
    },
  },
  computed: {
    currencyName() {
      return this.$store.state.currencyName;
    },
    rules() {
      return {
        onlyNumber: (v) =>
          !v ||
          /^-?\d+(\.\d+)?$/.test(String(v).replace(/,/g, "").trim()) ||
          this.$t("only numbers allowed"),
      };
    },
  },
  mounted() {
    if (this.$route.query.id) {
      this.personnelName = decodeURIComponent(this.$route.query.employeeName);
      this.workshopName = decodeURIComponent(this.$route.query.name);
    }
  },
  methods: {
    fetchApi(payload, template) {
      var app = this;
      let params = {
        page: payload.page,
        key: payload.type,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: app.currencyId,
      };
      return app.$axios
        .get(app.$endpoint + "salary-factor-config", { params })
        .then(function (response) {
          let list = response && response.data.data ? response.data.data : [];
          if (payload.page === 1 && !app.saleryFactorsTemplate && list.length > 0) {
            app.saleryFactorsTemplate = list[0];
          }
          return {
            items: list,
            hasMore: list.length === 10,
          };
        });
    },
    save(val) {
      // if (this.edit) {
      this.CreateCommandment(val);
      // }
    },
    CreateCommandment(val) {
      const isValid = this.$refs.form.validate();
      if (!isValid) {
        this.$emit("is-loading", false);
        this.$emit("again-ready-to-save");
        return;
      }
      if (isValid) {
        var app = this;
        app.loading = true;
        let employeeId = decodeURIComponent(this.$route.query.id);
        const startDate = app.startDate ? app.toBackendISO(app.startDate) : null;
        const contract_date = app.contract_date
          ? app.toBackendISO(app.contract_date)
          : null;
        const endDate = app.endDate ? app.toBackendISO(app.endDate) : null;
        let config = [...app.advantagesData, ...app.deductionsData].map((item) => ({
          name: item.name,
          level: item.level,
          id: item.id,
          code: item.code,
          amount: item.amount,
        }));
        const fixConfigs = {
          Eid_bonus_exemption: app.EidBonus,
          applying_the_law_seven_time: app.ApplyingTheLaw,
          base_monthly_salary: app.contract_number,
          supplementary_insurer: app.supplementaryInsurer,
          cost_insurer_percent: app.costInsurerPercent,
          jobless_insurer_percent: app.JoblessInsurerPercent,
          co_insurer_Percent: app.Co_InsurerPercent,
          tax_deduction_regulation: app.TaxDeductionRegulation,
          tax_deduction_supplementary: app.TaxDeductionSupplementary,
          fix_tax_percent: app.fixTaxPercent,
          contract_date: app.contract_date,
          contract_number: app.contract_number,
        };
        let id_ = Number(decodeURIComponent(app.$route?.query?.rowId || "0"));
        if (id_ == 0) {
          app.$axios
            .post(this.$endpoint + "salary-commitment", {
              hrm_employee_id: employeeId,
              start_date: startDate,
              end_date: endDate,
              hrm_salary_factor_config_id: app.CommitmentByConfigId,
              configs: config,
              fix_configs: fixConfigs,
            })
            .then((response) => {
              if (val) {
                app.return = false;
                app.$router.push(`/payroll/commandments/personnel/${employeeId}`);
              } else {
                this.EidBonus = false;
                this.ApplyingTheLaw = false;
                this.contract_number = null;
                this.supplementaryInsurer = null;
                this.costInsurerPercent = null;
                this.JoblessInsurerPercent = null;
                this.Co_InsurerPercent = null;
                this.TaxDeductionRegulation = null;
                this.TaxDeductionSupplementary = null;
                this.fixTaxPercent = null;
                this.startDate = null;
                this.contract_date = null;
                this.endDate = null;
                this.advantagesData.forEach((item) => {
                  item.amount = null;
                });
                this.deductionsData.forEach((item) => {
                  item.amount = null;
                });
                app.snakbarText = app.$t("alert-register-success");
                app.snakbarColor = "green";
                app.snakbar = true;
              }
            })
            .catch((err) => {
              app.loading = false;
              app.$emit("again-ready-to-save");
              app.serverErrorHandeler(err);
            })
            .finally(() => {
              app.$emit("again-ready-to-save");
              app.$emit("is-loading", false);
              app.loading = false;
            });
        } else {
          app.$axios
            .put(this.$endpoint + "salary-commitment/" + id_, {
              hrm_employee_id: employeeId,
              start_date: startDate,
              // contract_date: contract_date,
              end_date: endDate,
              hrm_salary_factor_config_id: app.CommitmentByConfigId,
              configs: config,
              fix_configs: fixConfigs,
            })
            .then((response) => {
              if (val) {
                app.return = false;
                app.$router.push(`/payroll/commandments/personnel/${employeeId}`);
              }
              app.snakbarText = app.$t("alert-register-success");
              app.snakbarColor = "green";
              app.snakbar = true;
            })
            .catch((err) => {
              app.loading = false;
              app.$emit("again-ready-to-save");
              app.serverErrorHandeler(err);
            })
            .finally(() => {
              app.$emit("again-ready-to-save");
              app.$emit("is-loading", false);
              app.loading = false;
            });
        }
      }
    },
    getSalaryCommitmentByConfigId(configId) {
      var app = this;
      app.loading = true;
      let id_ = Number(decodeURIComponent(app.$route?.query?.rowId || "0"));
      if (id_ == 0) {
        app.$axios
          .get(app.$endpoint + "salary-commitment/" + id_, {
            params: {
              salary_factor_config: configId,
            },
          })
          .then((response) => {
            const data = response.data || [];
            data.forEach((item) => {
              const obj = {
                name: item.name,
                level: item.level,
                id: item.id,
                code: item.code,
                amount: item.amount ?? 0,
              };

              if (item.level === "benefit") {
                app.advantagesData.push(obj);
              } else if (item.level === "deductions") {
                app.deductionsData.push(obj);
              }
            });
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => {
            app.loading = false;
          });
      } else {
        app.$axios
          .get(app.$endpoint + "salary-commitment/" + id_, {
            params: {
              salary_factor_config: configId,
            },
          })
          .then((response) => {
            const configs = response.data.configs || [];
            configs.forEach((item) => {
              const obj = {
                name: item.name,
                level: item.level,
                id: item.id,
                code: item.code,
                amount: item.amount ?? 0,
              };

              if (item.level === "benefit") {
                app.advantagesData.push(obj);
              } else if (item.level === "deductions") {
                app.deductionsData.push(obj);
              }
            });
            const data = response.data || [];
            let salary_template = data.salary_factor_config;
            if (salary_template != null && !this.hasHydratedEditTemplate) {
              const normalizedTemplate =
                typeof salary_template === "object"
                  ? salary_template
                  : { id: salary_template };
              this.isHydratingTemplate = true;
              this.saleryFactorsTemplate = normalizedTemplate;
              this.CommitmentByConfigId = normalizedTemplate.id;
              this.$nextTick(() => {
                this.isHydratingTemplate = false;
              });
              this.hasHydratedEditTemplate = true;
            }
            this.startDate = app.toJalali(data.start_date);
            this.endDate = app.toJalali(data.end_date);
            const res = response.data?.fix_configs;
            this.EidBonus = res?.Eid_bonus_exemption;
            this.ApplyingTheLaw = res.applying_the_law_seven_time;
            this.contract_number = res.contract_number;
            this.contract_date = res.contract_date;
            this.supplementaryInsurer = res.supplementary_insurer;
            this.costInsurerPercent = res.cost_insurer_percent;
            this.JoblessInsurerPercent = res.jobless_insurer_percent;
            this.Co_InsurerPercent = res.co_insurer_Percent;
            this.TaxDeductionRegulation = res.tax_deduction_regulation;
            this.TaxDeductionSupplementary = res.tax_deduction_supplementary;
            this.fixTaxPercent = res.fix_tax_percent;
          })
          .catch((err) => {
            app.serverErrorHandeler(err);
          })
          .finally(() => {
            app.loading = false;
          });
      }
    },
    openDialog() {
      this.isVisible = true;
    },
    handleDialog(val) {
      this.isVisible = val;
    },
    numberFormat(value) {
      return value || value == 0 ? this.$numberFormat(value) : "";
    },
    onAmountInput(value, index) {
      const numericValue = Number(value.toString().replace(/[^\d.-]/g, ""));
      this.advantagesData[index].amount = isNaN(numericValue) ? null : numericValue;
    },
    onAmountDeductionsInput(value, index) {
      const numericValue = Number(value.toString().replace(/[^\d.-]/g, ""));
      this.deductionsData[index].amount = isNaN(numericValue) ? null : numericValue;
    },
    onBaseContractInput(value) {
      const numericValue = Number(value.toString().replace(/[^\d.-]/g, ""));
      this.contract_number = isNaN(numericValue) ? null : numericValue;
    },
    onSupplementaryInsurerInput(value) {
      const numericValue = Number(value.toString().replace(/[^\d.-]/g, ""));
      this.supplementaryInsurer = isNaN(numericValue) ? null : numericValue;
    },
    // toBackendISO(jalaliDate) {
    //   if (!jalaliDate) return null;
    //   let generate = moment(jalaliDate, "jYYYY/jMM/jDD HH:mm:ss")
    //     .locale("en")
    //     .toDate()
    //     .toISOString();
    //   return generate;
    // },
    toBackendISO(jalaliDate) {
      if (!jalaliDate) return null;
      const m = moment(jalaliDate, "jYYYY/jMM/jDD");
      if (!m.isValid()) return null;
      return m.format("YYYY-MM-DD") + "T00:00:00+03:30";
    },
    toJalali(date) {
      if (!date) return this.$t("haveNot");
      const m = moment(date);
      if (!m.isValid()) {
        return this.$t("haveNot");
      }
      return m.format("jYYYY/jMM/jDD");
    },
  },
};
</script>

<style scoped>
.upload-box {
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  height: content;
}

.button-upload {
  color: #616161;
  max-height: 172px;
}
.uploadIMG {
  color: #616161;
  max-height: 172px;
}
::v-deep .upload-box .v-input__control {
  border: 2px dashed #ccc;
  border-radius: 8px;
  height: 100%;
}

::v-deep .upload-box .v-input__slot {
  justify-content: center;
  align-items: center;
  height: 100%;
}

::v-deep .upload-box input {
  display: none;
}
::-webkit-scrollbar {
  display: none;
}
</style>
